import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchRole, updateRole } from "actions/role";
import { fetchPermissions } from "actions/permission";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/Role/Form/index";

class RoleEdit extends Component {
  componentDidMount() {
    const { match, fetchRole, fetchPermissions } = this.props;
    const id = match.params.roleId;
    fetchRole(id, { partials: "permissions" });
    fetchPermissions({ limit: 999 });
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.role.data;

    let permissions = {};
    if (rest.permissions) {
      rest.permissions.forEach(permission => {
        permissions = { ...permissions, [permission.slug]: true };
      });
    }

    return Object.assign(
      {},
      {
        ...rest,
        permissions
      }
    );
  }

  updateRole(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updateRole, history } = this.props;

    toggleFullPageSpinner(true);

    updateRole(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated Role Success", infoClassName: "is-success" });
        history.push(`/roles`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.roleId;

    this.updateRole(id, data);
  };

  render() {
    const { role, permissions } = this.props;

    if (role.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        defaultValues={defaultValues}
        permissions={permissions}
      />
    );
  }
}

const mapStateToProps = ({ role, permissions }) => ({
  role,
  permissions
});

export default connect(
  mapStateToProps,
  {
    fetchRole,
    fetchPermissions,
    updateRole,
    toggleFullPageSpinner,
    toggleNotification
  }
)(RoleEdit);



// WEBPACK FOOTER //
// ./src/pages/Role/Edit/index.js